document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll(".platform-function__item-num");
  
    items.forEach(function(item, index) {
      // インデックスを元に連番を生成（0から始まる場合）
      const number = (index + 1).toString().padStart(2, "0");
  
      // テキストを挿入
      item.textContent = number;
    });
  });
  